enum USER_TYPE {
  STUDENT_IMPULS = 'impulsStudent',
  STANDARD = 'standard',
  PREMIUM = 'premium',
  DEMO = 'demo',
}

export default USER_TYPE;
